import React, {useLayoutEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {IHTMLCommentProps} from "./types";

/**
 * @param {{text: string}} props
 */
export const HTMLComment: React.FC<IHTMLCommentProps> = ({
        text,
    }: IHTMLCommentProps
) => {
  const ref = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    let el: HTMLSpanElement | null = null;
    let parent: ParentNode | null = null;
    let comm: Comment | null = null;

    if (ref.current) {
      el = ref.current;
      parent = el.parentNode;
      comm = (window || global).document.createComment(` ${text.trim()} `);
      try {
        if (parent && parent.contains(el)) {
          parent.replaceChild(comm, el);
        }
      } catch (err) {
        // Swallow error when replacing element with comment
      }
    }

    return () => {
      if(parent && el && comm) {
        parent.replaceChild(el, comm)
      }
    }
  }, []);

  return <span ref={ref} style={{ display: 'none' }} />;
};

HTMLComment.propTypes = {
  text: PropTypes.string.isRequired,
};

